export * from './ajax'
export * from './selects'



// WEBPACK FOOTER //
// ./src/api/index.js